<template>
	<div class="biochemical">
		<div class="biochemical-title">第四步、填寫生化信息（請注意單位）</div>
		<el-form
		>
			<el-row :gutter="10">
			  <el-col :span="24">
				  <div class="insert-title qjc-wid-100">血壓檢查</div>
			  </el-col>
			  <el-col :xs="24" :sm="24" :md="12" :lg="12" :xl="12">
				  <el-form-item
				  	label="收縮壓(SBP)"
				  >
				  	<el-input
				  		v-model="formData.sbp"
				  		@input="mustNumber('sbp')"
				  		placeholder="請輸入"
				  		@blur="inputRange('sbp', 90, 180)"
				  	>
				  		<div class="suffix qjc-fts-14" slot="suffix">
				  			mmHg
				  		</div>
				  	</el-input>
				  </el-form-item>
			  </el-col>
			  <el-col :xs="24" :sm="24" :md="12" :lg="12" :xl="12">
				  <el-form-item
				  	label="舒張壓(DBP)"
				  >
				  	<el-input
				  		v-model="formData.dbp"
				  		@input="mustNumber('dbp')"
				  		placeholder="請輸入"
				  		@blur="inputRange('dbp', 1, 90)"
				  	>
				  		<div class="suffix qjc-fts-14" slot="suffix">
				  			mmHg
				  		</div>
				  	</el-input>
				  </el-form-item>
			  </el-col>
			  <el-col :span="24">
				  <div class="insert-title qjc-wid-100">血常規檢查</div>
			  </el-col>
			  <el-col :xs="24" :sm="24" :md="12" :lg="12" :xl="12">
				  <el-form-item
				  	label="白細胞(WBC)"
				  >
				  	<el-input
				  		v-model="formData.examineObj.WBC.ve"
				  		@input="examineMustNumber('WBC')"
				  		placeholder="請輸入"
				  		@blur="inputRange('WBC', 0, 150)"
				  	>
				  		<div class="suffix qjc-fts-14" slot="suffix">
				  			10³/μL（10⁹/L）
				  		</div>
				  	</el-input>
				  </el-form-item>
			  </el-col>
			  <el-col :xs="24" :sm="24" :md="12" :lg="12" :xl="12">
				  <el-form-item
				  	label="血紅蛋白(HGB)"
				  >
				  	<el-input
				  		v-model="formData.examineObj.HGB.ve"
				  		@input="examineMustNumber('HGB')"
				  		placeholder="請輸入"
				  		@blur="inputRange('HGB', 1, 25, 10, 250)"
				  	>
				  		<div class="suffix qjc-fts-14" slot="suffix">
				  			<el-radio-group
				  				v-model="formData.examineObj.HGB.ut"
				  			>
				  				<el-radio label="A">g/dL</el-radio>
				  				<el-radio label="B">g/L</el-radio>
				  			</el-radio-group>
				  		</div>
				  	</el-input>
				  </el-form-item>
			  </el-col>
			  <el-col :xs="24" :sm="24" :md="12" :lg="12" :xl="12">
				  <el-form-item
				  	label="血小板計數(PLT)"
				  >
				  	<el-input
				  		v-model="formData.examineObj.PLT.ve"
				  		@input="examineMustNumber('PLT')"
				  		placeholder="請輸入"
				  		@blur="inputRange('PLT', 1, 1800)"
				  	>
				  		<div class="suffix qjc-fts-14" slot="suffix">
				  			10³/μl（10⁹/L）
				  		</div>
				  	</el-input>
				  </el-form-item>
			  </el-col>
			  <el-col :span="24">
				  <div class="insert-title qjc-wid-100">血糖檢查</div>
			  </el-col>
			  <el-col :xs="24" :sm="24" :md="12" :lg="12" :xl="12">
				  <el-form-item
				  	label="空腹血糖(FG)"
				  >
				  	<el-input
				  		v-model="formData.examineObj.FG.ve"
				  		@input="examineMustNumber('FG')"
				  		placeholder="請輸入"
				  		@blur="inputRange('FG', 30, 700, 1.5, 40)"
				  	>
				  		<div class="suffix qjc-fts-14" slot="suffix">
				  			<el-radio-group
				  				v-model="formData.examineObj.FG.ut"
				  			>
				  				<el-radio label="A">mg/dL</el-radio>
				  				<el-radio label="B">mmol/L</el-radio>
				  			</el-radio-group>
				  		</div>
				  	</el-input>
				  </el-form-item>
			  </el-col>
			  <el-col :xs="24" :sm="24" :md="12" :lg="12" :xl="12">
				  <el-form-item
				  	label="糖化血紅蛋白(HBA1C)"
				  >
				  	<el-input
				  		v-model="formData.examineObj.HBA1C.ve"
				  		@input="examineMustNumber('HBA1C')"
				  		placeholder="請輸入"
				  		@blur="inputRange('HBA1C', 1, 25, 0, 10)"
				  	>
				  		<div class="suffix qjc-fts-14" slot="suffix">
				  			<el-radio-group
				  				v-model="formData.examineObj.HBA1C.ut"
				  			>
				  				<el-radio label="A">%</el-radio>
				  				<el-radio label="B">mmol/L</el-radio>
				  			</el-radio-group>
				  		</div>
				  	</el-input>
				  </el-form-item>
			  </el-col>
			  <el-col :span="24">
				  <div class="insert-title qjc-wid-100">血脂檢查</div>
			  </el-col>
			  <el-col :xs="24" :sm="24" :md="12" :lg="12" :xl="12">
				  <el-form-item
				  	label="總膽固醇(CHOL)"
				  >
				  	<el-input
				  		v-model="formData.examineObj.CHOL.ve"
				  		@input="examineMustNumber('CHOL')"
				  		placeholder="請輸入"
				  		@blur="inputRange('CHOL', 50, 1100, 1.2, 28.5)"
				  	>
				  		<div class="suffix qjc-fts-14" slot="suffix">
				  			<el-radio-group
				  				v-model="formData.examineObj.CHOL.ut"
				  			>
				  				<el-radio label="A">mg/dL</el-radio>
				  				<el-radio label="B">mmol/L</el-radio>
				  			</el-radio-group>
				  		</div>
				  	</el-input>
				  </el-form-item>
			  </el-col>
			  <el-col :xs="24" :sm="24" :md="12" :lg="12" :xl="12">
				  <el-form-item
				  	label="低密度脂蛋白(LDLC)"
				  >
				  	<el-input
				  		v-model="formData.examineObj.LDLC.ve"
				  		@input="examineMustNumber('LDLC')"
				  		placeholder="請輸入"
				  		@blur="inputRange('LDLC', 1, 650, 0, 17)"
				  	>
				  		<div class="suffix qjc-fts-14" slot="suffix">
				  			<el-radio-group
				  				v-model="formData.examineObj.LDLC.ut"
				  			>
				  				<el-radio label="A">mg/dL</el-radio>
				  				<el-radio label="B">mmol/L</el-radio>
				  			</el-radio-group>
				  		</div>
				  	</el-input>
				  </el-form-item>
			  </el-col>
			  <el-col :xs="24" :sm="24" :md="12" :lg="12" :xl="12">
				  <el-form-item
				  	label="高密度脂蛋白(HDLC)"
				  >
				  	<el-input
				  		v-model="formData.examineObj.HDLC.ve"
				  		@input="examineMustNumber('HDLC')"
				  		placeholder="請輸入"
				  		@blur="inputRange('HDLC', 1, 250, 0, 7)"
				  	>
				  		<div class="suffix qjc-fts-14" slot="suffix">
				  			<el-radio-group
				  				v-model="formData.examineObj.HDLC.ut"
				  			>
				  				<el-radio label="A">mg/dL</el-radio>
				  				<el-radio label="B">mmol/L</el-radio>
				  			</el-radio-group>
				  		</div>
				  	</el-input>
				  </el-form-item>
			  </el-col>
			  <el-col :xs="24" :sm="24" :md="12" :lg="12" :xl="12">
				  <el-form-item
				  	label="甘油三酯(TG)"
				  >
				  	<el-input
				  		v-model="formData.examineObj.TG.ve"
				  		@input="examineMustNumber('TG')"
				  		placeholder="請輸入"
				  		@blur="inputRange('TG', 1, 9000, 0, 110)"
				  	>
				  		<div class="suffix qjc-fts-14" slot="suffix">
				  			<el-radio-group
				  				v-model="formData.examineObj.TG.ut"
				  			>
				  				<el-radio label="A">mg/dL</el-radio>
				  				<el-radio label="B">mmol/L</el-radio>
				  			</el-radio-group>
				  		</div>
				  	</el-input>
				  </el-form-item>
			  </el-col>
			  <el-col :span="24">
				  <div class="insert-title qjc-wid-100">腎功能檢查</div>
			  </el-col>
			  <el-col :xs="24" :sm="24" :md="12" :lg="12" :xl="12">
				  <el-form-item
				  	label="尿酸(UA)"
				  >
				  	<el-input
				  		v-model="formData.examineObj.UA.ve"
				  		@input="examineMustNumber('UA')"
				  		placeholder="請輸入"
				  		@blur="inputRange('UA', 0, 20, 0, 1200)"
				  	>
				  		<div class="suffix qjc-fts-14" slot="suffix">
				  			<el-radio-group
				  				v-model="formData.examineObj.UA.ut"
				  			>
				  				<el-radio label="A">mg/dL</el-radio>
				  				<el-radio label="B">μmol/L</el-radio>
				  			</el-radio-group>
				  		</div>
				  	</el-input>
				  </el-form-item>
			  </el-col>
			  <el-col :span="24">
				  <div class="footer-btn">
						<el-button @click="handlePrev" class="prev qjc-fts-16 qjc-block">上一步</el-button>
						<el-button @click="handleSubmit" :loading="submiting" class="next qjc-fts-16 qjc-block">確認提交</el-button>
					</div>
			  </el-col>
			</el-row>

			
			
			<el-dialog
			  title="提示"
			  :visible.sync="updateShow"
			  width="30%"
			  :before-close="handleUpdateClose">
			  <span>每份套餐的修改次數最多三次，請您確認修改內容</span>
			  <span slot="footer" class="dialog-footer">
				<el-button class="cancel-btn" @click="handleUpdateClose">取 消</el-button>
				<el-button class="submit-btn" type="primary" @click="submit">確 定</el-button>
			  </span>
			</el-dialog>
		</el-form>
	</div>
</template>

<script>
	import { newQuestionsSubmit, isHKPhone } from '../../../js/axios'
	import {
		Base64
	} from 'js-base64'

	export default{
		name: 'biochemical',
		data() {
			return {
				submiting: false,
				updateShow: false, //修改确认弹窗
				isSuper: false,
				examineList:[
					{"ne": "WBC", "ve": "", "ut": "A", "name": "白細胞(WBC)"},
					{"ne": "HGB", "ve": "", "ut": "A", "name": "血紅蛋白(HGB)"},
					{"ne": "PLT", "ve": "", "ut": "A", "name": "血小板(PLT)"},
					{"ne": "FG", "ve": "", "ut": "B", "name": "空腹血糖(FG)"},
					{"ne": "HBA1C", "ve": "", "ut": "A", "name": "糖化血紅蛋白(HBA1C)"},
					{"ne": "CHOL", "ve": "", "ut": "B", "name": "總膽固醇(CHOL)"},
					{"ne": "LDLC", "ve": "", "ut": "B", "name": "低密度脂蛋白(LDLC)"},
					{"ne": "HDLC", "ve": "", "ut": "B", "name": "高密度脂蛋白(HDLC)"},
					{"ne": "TG", "ve": "", "ut": "B", "name": "甘油三酯(TG)"},
					{"ne": "UA", "ve": "", "ut": "B", "name": "尿酸(UA)"},
				]
			}
		},
		props: ['type', 'isBo', 'formData', 'clearData'],
		inject: ['handleRefresh'],
		watch:{
			'formData.examineObj':{
				handler(val){
					if(val){
						this.formData.examine = Object.entries(val).map(item => item[1])
					}
					
				},
				deep:true,
				immediate:true
			}
		},
		mounted() {
			let examineArry = [
				{"ne": "WBC", "ve": "", "ut": "A"},
				{"ne": "HGB", "ve": "", "ut": "A"},
				{"ne": "PLT", "ve": "", "ut": "A"},
				{"ne": "FG", "ve": "", "ut": "B"},
				{"ne": "HBA1C", "ve": "", "ut": "A"},
				{"ne": "CHOL", "ve": "", "ut": "B"},
				{"ne": "LDLC", "ve": "", "ut": "B"},
				{"ne": "HDLC", "ve": "", "ut": "B"},
				{"ne": "TG", "ve": "", "ut": "B"},
				{"ne": "UA", "ve": "", "ut": "B"},
			]
			this.formData.examine.map((item, index) => {
				if(item.ve != '') {
					examineArry[index].ve = item.ve
					examineArry[index].ut = item.ut
				}
			})
			this.formData.examine = examineArry
			
		},
		methods: {
			handleUpdateClose() {
				this.updateShow = false;
			},
			handleSubmit() {
				this.submit()
			},
			// 确认提交
			submit() {
				if(!this.verifyNull()){
					//是否存在未填写信息
					
					if(this.type == 'update') {
						this.formData.act = 'update'
					}
					if(this.formData.examdate == ''){
						this.formData.examdate = Date.parse(new Date()) / 1000
					}
					
					const formData = JSON.parse(JSON.stringify(this.formData))
					this.submiting = true;
					formData.birth = formData.birth.split('/').join('')
					formData.examine = Object.entries(formData.examineObj).map(item => item[1])
					
					delete formData.area
					delete formData.drink
					delete formData.smoke
					delete formData.habeat
					delete formData.vege
					delete formData.habsport
					delete formData.sleep
					delete formData.disease
					delete formData.oper
					delete formData.famdis
					delete formData.fat
					delete formData.package
					delete formData.type
					delete formData.loa 
					delete formData.examdate 
					delete formData.examineObj 
					
				
					
					newQuestionsSubmit(formData).then(res => {
						
						this.submiting = false;
						
						if(res.code == 200){
							this.updateShow = false;
							sessionStorage.removeItem('report_id')
							if(res.data){
								const {id} = JSON.parse(Base64.decode(res.data))
								this.viewReport(id)
							}
							delete this.formData.act
							this.$emit('clearData', {});
							this.$emit('checkTab', 'Personal');
							
							this.handleRefresh();
							
						}else{
							if(this.formData.birth.split('/').length <= 1) {
								let newArr = this.formData.birth.split('')
								newArr.splice(4, 0, '/')
								newArr.splice(-2, 0, '/')
								this.formData.birth = newArr.join('')
							}
							this.updateShow = false;
							this.$myAlert({
								type: 'fail',
								content: res.msg
							});
						}
					});
				}
		
			},
			viewReport(id) {
				window.open('/report/m22Report.html?id=' + id);

			},
			//验证不为空
			verifyNull() {
				let examineList = [
					{"ne": "WBC", "ve": "", "ut": "A", "name": "白細胞(WBC)"},
					{"ne": "HGB", "ve": "", "ut": "A", "name": "血紅蛋白(HGB)"},
					{"ne": "PLT", "ve": "", "ut": "A", "name": "血小板(PLT)"},
					{"ne": "FG", "ve": "", "ut": "B", "name": "空腹血糖(FG)"},
					{"ne": "HBA1C", "ve": "", "ut": "A", "name": "糖化血紅蛋白(HBA1C)"},
					{"ne": "CHOL", "ve": "", "ut": "B", "name": "總膽固醇(CHOL)"},
					{"ne": "LDLC", "ve": "", "ut": "B", "name": "低密度脂蛋白(LDLC)"},
					{"ne": "HDLC", "ve": "", "ut": "B", "name": "高密度脂蛋白(HDLC)"},
					{"ne": "TG", "ve": "", "ut": "B", "name": "甘油三酯(TG)"},
					{"ne": "UA", "ve": "", "ut": "B", "name": "尿酸(UA)"},
				];
				for(var i=0;i<this.formData.examine.length;i++){
					if(this.formData.examine[i].ve == ''){// i=15(肾小球过滤率)暂时可为空
						this.$myAlert({
							title: '不能為空',
							content: '請輸入' + examineList[i].name
						});
						return true;
					}
				}
				
				if(this.formData.sbp == '') {
					this.$myAlert({
						title: '不能為空',
						content: '請輸入收縮壓'
					});
					return true;
				}
				if(this.formData.dbp == '') {
					this.$myAlert({
						title: '不能為空',
						content: '請輸入舒張壓'
					});
					return true;
				}
				
				return false;
			},
			
			//必须输入数字 参数对应examine下标
			mustNumber(index) {
				this.formData[index] = this.formData[index].replace(/[^\d\.]/g,"").replace('.',"$").replace(/\./g,"").replace("$",".")
			},
			
			
			examineMustNumber(index){
				this.formData.examineObj[index].ve = this.formData.examineObj[index].ve.replace(/[^\d\.]/g,"").replace('.',"$").replace(/\./g,"").replace("$",".")
			},
			
			//输入偏差提示 参数1.data中examine下标  2.最小值(存在单位切换时为A单位最小值)  3.最大值(存在单位切换时为A单位最大值)  4.B最小值(存在单位切换时为B单位最小值) 5.B最大值(存在单位切换时为B单位最小值)
			inputRange(index, min, max, min2, max2){
				if(index == 'sbp') {
					if(this.formData.sbp != '' && (this.formData.sbp < min || this.formData.sbp > max)){
						this.$myAlert({
							title: '確認輸入信息',
							content: "您填寫的結果可能存在較大偏差，請您仔細核對該數值和所用單位是否正確並與您的報告一致。<br/>若您已經核對確認，並堅持以該結果進行提交和評估，我們可能會根據大數據算法對該結果進行一定程度上的修正和處理，以提供更合理的大數據評估結果和建議。"
						});
						return
					}
						return
				}
				if(index == 'dbp') {
					if(this.formData.dbp != '' && (this.formData.dbp < min || this.formData.dbp > max)){
						this.$myAlert({
							title: '確認輸入信息',
							content: "您填寫的結果可能存在較大偏差，請您仔細核對該數值和所用單位是否正確並與您的報告一致。<br/>若您已經核對確認，並堅持以該結果進行提交和評估，我們可能會根據大數據算法對該結果進行一定程度上的修正和處理，以提供更合理的大數據評估結果和建議。"
						});
						return
					}
					return
				}
				if(this.formData.examineObj[index].ve != ''){
					if(min2 || max2 && this.formData.examineObj[index].ut == 'B'){//存在单位切换且为单位为B值时
						if(this.formData.examineObj[index].ve < min2 || this.formData.examineObj[index].ve > max2){
							this.$myAlert({
								title: '確認輸入信息',
								content: "您填寫的結果可能存在較大偏差，請您仔細核對該數值和所用單位是否正確並與您的報告一致。<br/>若您已經核對確認，並堅持以該結果進行提交和評估，我們可能會根據大數據算法對該結果進行一定程度上的修正和處理，以提供更合理的大數據評估結果和建議。"
							});
						}
					}else{
						if(this.formData.examineObj[index].ve < min || this.formData.examineObj[index].ve > max){
							this.$myAlert({
								title: '確認輸入信息',
								content: "您填寫的結果可能存在較大偏差，請您仔細核對該數值和所用單位是否正確並與您的報告一致。<br/>若您已經核對確認，並堅持以該結果進行提交和評估，我們可能會根據大數據算法對該結果進行一定程度上的修正和處理，以提供更合理的大數據評估結果和建議。"
							});
						}
					}
				}
				
			},
			
			handlePrev() {
				this.$emit('checkTab', 'Bodily')
			},
		}
	}
</script>

<style scoped>

	.biochemical >>> .el-input{
		height: 32px;
		line-height: 32px;
	}
	.biochemical >>> .el-input input{
		height: 32px;
		line-height: 14px;
		font-size: 14px;
		padding: 10px 12px;
	}
	
	.biochemical >>> .el-input {
		width: 100%;
		max-width: 400px;
	}
	
	.biochemical>>>.el-form-item__label {
		float: none;
	}
	

</style>
<style lang="scss" scoped>
	.biochemical{
		padding-top: 32px;
		
		.biochemical-title{
			font-weight: bold;
			color: #000;
		}
		
		.form-cell {
			display: flex;
			flex-direction: row;
			flex-wrap: wrap;
			width: 100%;
		}
		
		.insert-title {
			position: relative;
			font-size: 16px;
			font-family: PingFangSC-Medium, PingFang SC;
			font-weight: 500;
			color: #293033;
			line-height: 16px;
			padding-bottom: 15px;
			border-bottom: 1px solid #E5E8F5;
			margin-bottom: 8px;
			
			&::before{
				position: absolute;
				left: -24px;
				top: 0;
				content: '';
				width: 4px;
				height: 20px;
				background-color: #6883FB;
			}
		}
		
		.el-form{
			margin-top: 22px;
			
			.el-form-item{
				
				
				
				.el-input{
					
					.el-radio{
						font-weight: normal;
						color: #777F8F;
					}
					.suffix{
						color: #777F8F;
						margin-right: 16px;
						
						sub{
							display: inline-block;
							vertical-align: baseline;
							font-size: inherit;
							transform: translateY(9%)scale(.65);
						}
						sup{
							display: inline-block;
							vertical-align: top;
							font-size: inherit;
							transform: translateY(-9%)scale(.65);
						}
					}
				}
				
				.submit{
					width: 200px;
					height: 48px;
					margin-top: 40px;
				}
			}
		}
		
	}
	
	.footer-btn {
		display: flex;
		justify-content: center;
		align-items: center;
		margin-top: 40px;
	}
			
	.next{
		width: 96px;
		height: 34px;
		border-radius: 17px;
		border: none;
		font-size: 14px;
		font-family: PingFangSC-Medium, PingFang SC;
		font-weight: 500;
		color: #fff;
	}
	.prev {
		width: 96px;
		height: 34px;
		border-radius: 17px;
		border: 1px solid #6883FB;
		font-size: 14px;
		font-family: PingFangSC-Medium, PingFang SC;
		font-weight: 500;
		color: #6883FB;
		background-color: #fff;
		margin-right: 24px;
	}
	
	
	.cancel-btn {
		width: 80px;
		height: 40px;
		color: #606266;
		background-color: #fff;
	}
	
	.submit-btn {
		width: 80px;
		height: 40px;
		background-color: #6681FA;
		border: none;
	}
</style>
